import { Check, Edit2, X, User } from "lucide-react";

export function ShoppingItem({ item, onToggle, onEdit, onDelete }) {
  return (
    <div
      className={`flex items-center gap-4 p-3 rounded-xl transition-all ${
        item.checked
          ? "bg-slate-800/30 opacity-60"
          : "bg-slate-800/50 hover:bg-slate-800"
      }`}
      data-testid={`shopping-item-${item.id}`}
    >
      <button
        onClick={() => onToggle(item)}
        className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
          item.checked
            ? "bg-emerald-500 border-emerald-500"
            : "border-slate-600 hover:border-indigo-500"
        }`}
        data-testid={`toggle-item-${item.id}`}
      >
        {item.checked && <Check size={14} className="text-white" />}
      </button>

      <div className="flex-1 min-w-0">
        <p
          className={`text-white ${
            item.checked ? "line-through text-slate-500" : ""
          }`}
        >
          {item.name}
          {item.quantity && (
            <span className="text-slate-400 ml-2">({item.quantity})</span>
          )}
        </p>
        {item.assigned_to_name && (
          <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
            <User size={10} />
            {item.assigned_to_name}
          </p>
        )}
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={() => onEdit(item)}
          className="p-2 text-slate-500 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
          data-testid={`edit-item-${item.id}`}
        >
          <Edit2 size={16} />
        </button>
        <button
          onClick={() => onDelete(item.id)}
          className="p-2 text-slate-500 hover:text-red-400 hover:bg-slate-700 rounded-lg transition-colors"
          data-testid={`delete-item-${item.id}`}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
